import { Link, Stack, Typography } from "@mui/material";
import { Empty, ZfpLogo } from "@zfp-akademie-a-s/zfp-design";
import { ANALYZER_EMAIL } from "Infrastructure/Config/constants";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { ReactNode } from "react";

type Props = {
  /** What went wrong at a glance, e.g. BlockedIcon for a missing page or LockIcon for missing access. */
  icon: ReactNode;
  title: string;
  subtitle: string;
  actions?: ReactNode;
};

// An error page outside the app's frame: the logo, then the package's Empty in the error colour, as Admin's error
// pages, with the address to write to
export const EmptyPage = ({ icon, title, subtitle, actions }: Props) => {
  const { t } = useResource();

  return (
    <Stack alignItems="center" spacing={Spacing.XXL} mt={Spacing.XXXL} px={Spacing.XL}>
      <ZfpLogo />
      <Empty
        icon={icon}
        color="error"
        title={title}
        text={subtitle}
        content={
          <Typography variant="caption" color="text.secondary">
            {t(Resources.Errors.ContactUs)}{" "}
            <Link href={`mailto:${ANALYZER_EMAIL}`} underline="hover">
              {ANALYZER_EMAIL}
            </Link>
          </Typography>
        }
        actions={actions}
      />
    </Stack>
  );
};
